var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calculated-details-wrapper" },
    [
      _c(
        "div",
        { staticClass: "row align-items-end" },
        [
          _c(
            "field",
            {
              attrs: {
                "size-class": "col-lg-8 col-12",
                title: _vm.$t("direct-to-lender.fees.principalAmount"),
                "side-label": true,
                "side-label-size": "col-lg-2 col-auto",
                "container-class": "dollar-prepend w-30",
                calculated: true,
              },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "principal-amount",
                  placeholder: "0.00",
                  calculated: true,
                  decimals: 2,
                  "class-name": "calculated dollar",
                  "allow-minus": "",
                  value: _vm.currentCalculatedDetails.principalAmount,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            {
              attrs: {
                "size-class": "col-lg-8 col-12",
                title: _vm.$t("direct-to-lender.fees.totalDeductibleFees"),
                "side-label": true,
                calculated: true,
                decimals: 2,
                "side-label-size": "col-lg-2 col-auto",
                "container-class": "dollar-prepend w-30",
              },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "total-deductible-fees",
                  placeholder: "0.00",
                  "class-name": "calculated dollar",
                  calculated: true,
                  decimals: 2,
                  "allow-minus": "",
                  value: _vm.currentCalculatedDetails.totalFees,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            {
              attrs: {
                "size-class": "col-lg-8 col-12",
                title: _vm.$t("direct-to-lender.fees.netAdvanceOfFunds"),
                "side-label": true,
                decimals: 2,
                "side-label-size": "col-lg-2 col-auto",
                "container-class": "dollar-prepend w-30",
                calculated: true,
              },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "net-advance-funds",
                  placeholder: "0.00",
                  "class-name": "calculated dollar",
                  calculated: true,
                  decimals: 2,
                  "allow-minus": "",
                  value: _vm.currentCalculatedDetails.netFunds,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            {
              attrs: {
                "size-class": "col-lg-8 col-12",
                title: _vm.$t("direct-to-lender.fees.totalCostOfBorrowing"),
                "side-label": true,
                decimals: 2,
                calculated: true,
                "side-label-size": "col-lg-2 col-auto",
                "container-class": "perc-prepend  w-30",
              },
            },
            [
              _c("text-section", {
                attrs: {
                  id: "apr-field",
                  name: "apr",
                  placeholder: "0.00",
                  "class-name": "calculated-dd",
                  calculated: _vm.loadingApr,
                  disabled: _vm.isAprDisabled,
                  decimals: 2,
                  value: _vm.currentCalculatedDetails.apr || 0,
                },
                on: { change: _vm.handleAprChange },
              }),
              _vm._v(" "),
              _c("checkbox-section", {
                attrs: {
                  id: "apr-checkbox",
                  name: "apr-checkbox",
                  label: _vm.$t("direct-to-lender.fees.overrideAPR"),
                  checked: _vm.currentCalculatedDetails.overrideApr,
                  disabled: _vm.loadingApr,
                },
                on: { change: _vm.handleCheckboxChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("generic-modal", {
        attrs: { id: "override-modal", title: "Override APR" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("direct-to-lender.fees.overrideAPR")) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", { staticClass: "justified" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("direct-to-lender.fees.overrideAPRModal")) +
                      "\n      "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }